import { Button, Tabs } from "antd";
import SettingsProgMain from "./settings-prog-main";
import SettingsProgLicenses from "./settings-prog-licenses";
import SettingsProgPrices from "./settings-prog-prices";

const SettingsProg = ({ progId, onClose }) => {
  const handleClose = (refresh) => onClose(refresh);

  return (
    <>
      <div className="cloud-modal-overlay" onClick={() => handleClose(false)} />
      <div className="cloud-modal-license-order-keys" style={{ maxWidth: "90%" }}>
        <div className="cloud-modal-header">
          <h3>Программа #{progId}</h3>
          <Button onClick={() => handleClose(false)} type="text">×</Button>
        </div>
        <div className="cloud-modal-content">
          <Tabs
            items={[
              {
                key: 'program',
                label: 'Программа',
                children: <SettingsProgMain progId={progId} onClose={handleClose} />,
              },
              {
                key: 'licenses',
                label: 'Виды лицензий',
                children: <SettingsProgLicenses progId={progId} />,
              },
              {
                key: 'prices',
                label: 'Цены',
                children: <SettingsProgPrices progId={progId} />,
              },
            ]}
            type="card"
          />
        </div>
      </div>
    </>
  );
};

export default SettingsProg;